"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AppState = _interopRequireDefault(require("composer-lib/data/model/AppState"));

var _constants = require("composer-lib/lib/constants");

var _KeyCodes = require("UIComponents/constants/KeyCodes");

var _editorConfigs = require("composer-lib/lib/editorConfigs");

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _ComposerSettings = _interopRequireDefault(require("composer-lib/data/model/ComposerSettings"));

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _lockHelpers = require("composer-lib/lib/helpers/lockHelpers");

var _convertEvernoteToHTML = _interopRequireDefault(require("composer-lib/lib/convertEvernoteToHTML"));

var _convertGoogleToHTML = require("composer-lib/lib/convertGoogleToHTML");

var _convertMSWordToHTML = _interopRequireDefault(require("composer-lib/lib/convertMSWordToHTML"));

var _contentStateModifier = require("composer-lib/lib/contentStateModifier");

var _classnames = _interopRequireDefault(require("classnames"));

var _helpers = require("composer-lib/lib/helpers");

var _draftExtend = require("draft-extend");

var _draftJs = require("draft-js");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _utils = require("composer-lib/lib/utils");

var _GoogleDocs = _interopRequireDefault(require("composer-lib/data/model/GoogleDocs"));

var _I18n = _interopRequireDefault(require("I18n"));

var _reactKeybindings = require("react-keybindings");

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _Pages = _interopRequireDefault(require("composer-lib/data/model/Pages"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _immutable = require("immutable");

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _conversationsHelpers = require("composer-lib/lib/helpers/conversationsHelpers");

var _UsageTracking = require("composer-lib/lib/UsageTracking");

var _UIBadge = _interopRequireDefault(require("UIComponents/badge/UIBadge"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _UIFormLabel = _interopRequireDefault(require("UIComponents/form/UIFormLabel"));

var _UserAttributes = _interopRequireDefault(require("composer-lib/data/model/UserAttributes"));

var HANDLED = _constants.DRAFT_CANCELLABLE_HANDLERS.HANDLED,
    NOT_HANDLED = _constants.DRAFT_CANCELLABLE_HANDLERS.NOT_HANDLED;
var WORD_TEST = /<meta name=ProgId content=Word\.Document>/;
var DOCS_TEST = /id="docs-internal-guid/; // Evernote always puts an empty title in their HTML because :shrug:

var EVERNOTE_TEST = /<head><title><\/title><\/head>/;
var renderMessage = (0, _utils.getMessageRenderer)('composer-lib.composer');

function getScrollableContainer() {
  var container = document.querySelector("." + _constants.EDITORS_CONTAINER_CLASSNAME);
  return container;
}

var BodyEditor = (0, _createReactClass.default)({
  displayName: "BodyEditor",
  mixins: [_ComponentWithPartials.default],
  propTypes: {
    addKeyCommandListener: _propTypes.default.func.isRequired,
    addToast: _propTypes.default.func.isRequired,
    app: _propTypes.default.instanceOf(_AppState.default).isRequired,
    auth: _propTypes.default.object,
    autoFocus: _propTypes.default.bool.isRequired,
    clipLinkLoaded: _propTypes.default.func.isRequired,
    composerSettings: _propTypes.default.instanceOf(_ComposerSettings.default).isRequired,
    composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
    containerClassNames: _propTypes.default.string,
    editorClassNames: _propTypes.default.string,
    properties: _propTypes.default.instanceOf(_immutable.Map).isRequired,
    questionsMap: _propTypes.default.instanceOf(_immutable.Map).isRequired,
    googleDocs: _propTypes.default.instanceOf(_GoogleDocs.default).isRequired,
    handleKeyCommand: _propTypes.default.func.isRequired,

    /* eslint-disable react/no-unused-prop-types */
    hideAddConversationButton: _propTypes.default.func.isRequired,
    insertImage: _propTypes.default.func.isRequired,
    insertVideo: _propTypes.default.func.isRequired,
    insertEmbed: _propTypes.default.func.isRequired,
    insertQuestionAndAnswer: _propTypes.default.func.isRequired,
    saveQuestion: _propTypes.default.func.isRequired,

    /* eslint-enable react/no-unused-prop-types */
    insertableLoaded: _propTypes.default.func.isRequired,
    lock: _propTypes.default.instanceOf(_Lock.default).isRequired,
    pages: _propTypes.default.instanceOf(_Pages.default).isRequired,
    registerListener: _propTypes.default.func,
    required: _propTypes.default.bool.isRequired,
    removeKeyCommandListener: _propTypes.default.func.isRequired,
    restoreSelection: _propTypes.default.func.isRequired,
    saveState: _propTypes.default.instanceOf(_SaveState.default).isRequired,
    setBodyEditorActive: _propTypes.default.func.isRequired,
    setEditorLoaded: _propTypes.default.func,
    showGoogleAuthModal: _propTypes.default.func.isRequired,
    showGoogleDocsPicker: _propTypes.default.func.isRequired,
    showLabel: _propTypes.default.bool.isRequired,
    tabIndex: _propTypes.default.string,
    updateContentToSave: _propTypes.default.func.isRequired,
    updateUserAttribute: _propTypes.default.func.isRequired,
    userAttributes: _propTypes.default.instanceOf(_UserAttributes.default).isRequired
  },
  contextTypes: {
    gates: _propTypes.default.instanceOf(_immutable.Set)
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    this.updateHelpers = (0, _helpers.makeComposerHelperUpdater)(this, [_helpers.ComposerHelperNames.SAVE_CHANGED_COMPOSITION, _helpers.ComposerHelperNames.DEBOUNCED_SAVE_CHANGED_COMPOSITION, _helpers.ComposerHelperNames.ON_INSERT_IMAGE_CHANGE, _helpers.ComposerHelperNames.ON_INSERT_VIDEO_CHANGE, _helpers.ComposerHelperNames.ON_INSERT_EMBED_CHANGE, _helpers.ComposerHelperNames.ON_INSERT_QUESTION_AND_ANSWER]);
    this.updateHelpers();
    this.buildEditor();
  },
  componentDidMount: function componentDidMount() {
    var _this$props = this.props,
        registerListener = _this$props.registerListener,
        autoFocus = _this$props.autoFocus;
    var commentsOnly = this.getCommentsOnly();

    if (!commentsOnly) {
      registerListener('cmd+s', this.handleSave);
      registerListener('cmd+2', this.partial(this.toggleHeader, 'header-two'));
      registerListener('cmd+3', this.partial(this.toggleHeader, 'header-three'));
      registerListener('backspace', this.handleBackspace);
    } // Set data prop on contenteditable so Grammarly Chrome Extension doesn't load in this editor


    if (this._editor) {
      var contentEditable = _reactDom.default.findDOMNode(this._editor).querySelector('[contenteditable=true]');

      if (contentEditable) {
        contentEditable.setAttribute('data-gramm', false);
      }
    }

    if (autoFocus) {
      this.focus();
    }
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var saveState = this.props.saveState;
    var nextSaveState = nextProps.saveState;
    this.updateHelpers(nextProps);

    if (nextSaveState.contentChanged && !(0, _immutable.is)(saveState.content, nextSaveState.content)) {
      this.debouncedSaveChangedComposition();
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var _this$props2 = this.props,
        app = _this$props2.app,
        saveState = _this$props2.saveState;

    if (!app.loaded) {
      this.props.setEditorLoaded();
    }

    if (prevProps.saveState.insertableLoading && !saveState.insertableLoading) {
      // We still need another manual focus after inserting an image or clip, but the selection
      // state gets reset to the top when we do this, so we also need to restore the selection state.
      this.blur();
      this.focus(); // Manual blur/focus resets the scroll position, so we have to reset it

      this.resetScrollTop();
      this.props.restoreSelection(prevProps.saveState.content.getSelection()); // Manual save after inserting image or clip, since we don't use standard onChange which would autosave.

      this.saveChangedComposition();
    } // Handle full page (link) clip insertion separately for now


    if (!prevProps.saveState.clipLinkLoading && saveState.clipLinkLoading) {
      this.props.clipLinkLoaded();
    }

    if (this.userHasPastedContent) {
      this.userHasPastedContent = false;
      this.blur();
      this.focus();
      this.scrollToPastedContent();
    }

    if (this.shouldUpdateEditor(prevProps)) {
      this.buildEditor();
      this.forceUpdate();
    }
  },
  shouldUpdateEditor: function shouldUpdateEditor(prevProps) {
    return this.props.questionsMap && !this.props.questionsMap.equals(prevProps.questionsMap) || this.props.properties && !this.props.properties.equals(prevProps.properties) || this.props.saveQuestion !== prevProps.saveQuestion;
  },
  saveScrollTop: function saveScrollTop() {
    var container = getScrollableContainer();

    if (container) {
      this.originalScrollTop = container.scrollTop;
    }
  },
  // Resets container scroll position to saved position
  resetScrollTop: function resetScrollTop() {
    var container = getScrollableContainer();

    if (container && this.originalScrollTop) {
      container.scrollTop = this.originalScrollTop;
    }
  },
  scrollToPastedContent: function scrollToPastedContent() {
    var container = getScrollableContainer();
    var editorState = this.getEditorState();
    var selection = editorState.getSelection();
    var focusKey = selection.getFocusKey();
    var focusOffset = selection.getFocusOffset();
    var parent = container && document.querySelector("[data-offset-key=\"" + focusKey + "-0-0\"]", container);
    var focusedElements = container && document.querySelectorAll("span[data-offset-key^=\"" + focusKey + "-\"]", container);

    if (parent && focusedElements.length > 0) {
      var selectedElement = parent;

      for (var i = 0; i < focusedElements.length; i++) {
        selectedElement = focusedElements[i];
        focusOffset -= focusedElements[i].innerText.length;

        if (focusOffset <= 0) {
          break;
        }
      }

      container.scrollTop = parent.offsetTop + selectedElement.offsetTop;
    }
  },
  handleInsertableLoaded: function handleInsertableLoaded() {
    var saveState = this.props.saveState; // We check if we have any insertable loading, otherwise we don't need to update the state.

    if (saveState.insertableLoading) {
      this.saveScrollTop();
      this.props.insertableLoaded();
    }
  },
  getEditorState: function getEditorState() {
    return this.props.saveState.content;
  },
  getPages: function getPages() {
    return (0, _utils.getMemoizedPages)(this.props.pages);
  },
  buildEditorOptions: function buildEditorOptions() {
    var _this$props3 = this.props,
        addKeyCommandListener = _this$props3.addKeyCommandListener,
        removeKeyCommandListener = _this$props3.removeKeyCommandListener,
        properties = _this$props3.properties,
        composerSettings = _this$props3.composerSettings,
        composition = _this$props3.composition,
        questionsMap = _this$props3.questionsMap,
        saveQuestion = _this$props3.saveQuestion;
    var props = {
      addKeyCommandListener: addKeyCommandListener,
      addToast: this.props.addToast,
      properties: properties,
      questionsMap: questionsMap,
      saveQuestion: saveQuestion,
      originId: composition.getIn(['data', 'originId']),
      getAuth: this.getAuth,
      getCommentsOnly: this.getCommentsOnly,
      getEditorState: this.getEditorState,
      getInsertEmbedEnabled: this.getInsertEmbedEnabled,
      getInsertVideoEnabled: this.getInsertVideoEnabled,
      getInsertImageEnabled: this.getInsertImageEnabled,
      getIsCollectBeta: this.getIsCollectBeta,
      getUserAttributes: this.getUserAttributes,
      getInsertQuestionAndAnswerEnabled: this.getInsertQuestionAndAnswerEnabled,
      onInsertableLoaded: this.handleInsertableLoaded,
      onInsertImageChange: this.onInsertImageChange,
      onInsertVideoChange: this.onInsertVideoChange,
      onInsertEmbedChange: this.onInsertEmbedChange,
      onInsertQuestionAndAnswerChange: this.onInsertQuestionAndAnswerChange,
      getReadOnly: this.getReadOnly,
      setReadOnly: this.setReadOnly,
      removeKeyCommandListener: removeKeyCommandListener,
      updateUserAttribute: this.props.updateUserAttribute
    };
    return {
      getPages: this.getPages,
      fileManagerUploadedFileAccess: composerSettings.fileManagerUploadedFileAccess,
      props: props
    };
  },
  buildEditor: function buildEditor() {
    var composerSettings = this.props.composerSettings;
    this.EditorWithPlugins = (0, _editorConfigs.bodyEditorConfig)(composerSettings.richTextStyles, composerSettings.features, composerSettings.betas, this.buildEditorOptions())(_draftExtend.Editor);
  },
  getReadOnly: function getReadOnly() {
    var composition = this.props.composition;
    var _this$props$saveState = this.props.saveState,
        highlighted = _this$props$saveState.highlighted,
        readOnly = _this$props$saveState.readOnly;
    return highlighted || readOnly || composition.isReadOnly();
  },
  getIsCollectBeta: function getIsCollectBeta() {
    return !!this.context.gates.get('cos_blog_collect_beta');
  },
  getInsertEmbedEnabled: function getInsertEmbedEnabled() {
    return !!this.props.composerSettings.get('features')[_constants.ComposerFeatures.EMBED];
  },
  getInsertVideoEnabled: function getInsertVideoEnabled() {
    return !!this.props.composerSettings.get('features')[_constants.ComposerFeatures.VIDEO];
  },
  getInsertImageEnabled: function getInsertImageEnabled() {
    var features = this.props.composerSettings.get('features');
    return _constants.ComposerFeatures.IMAGE in features || _constants.ComposerFeatures.IMAGE_V2 in features;
  },
  getInsertQuestionAndAnswerEnabled: function getInsertQuestionAndAnswerEnabled() {
    return !!this.props.composerSettings.get('features')[_constants.ComposerFeatures.QUESTION_AND_ANSWER];
  },
  getCommentsOnly: function getCommentsOnly() {
    var _this$props4 = this.props,
        auth = _this$props4.auth,
        lock = _this$props4.lock,
        saveState = _this$props4.saveState;
    return (0, _lockHelpers.compositionLocked)(lock, auth, saveState);
  },
  getUserAttributes: function getUserAttributes() {
    return this.props.userAttributes;
  },
  getAuth: function getAuth() {
    return this.props.auth;
  },
  handleSave: function handleSave(e) {
    e.preventDefault();
    (0, _UsageTracking.trackEvent)({
      action: 'save-via-keyboard-shortcut',
      name: _constants.AmplitudeEvents.COMPOSITION_INTERACTION.INTERACTION
    });
    this.saveChangedComposition();
  },
  toggleHeader: function toggleHeader(header, e) {
    e.preventDefault();
    this.props.updateContentToSave(_draftJs.RichUtils.toggleBlockType(this.props.saveState.content, header));
  },
  handleBackspace: function handleBackspace(e) {
    if (this.getCommentsOnly() || this.getReadOnly() || e.target.className.match(/hs-input/)) {
      return null;
    }

    return e.preventDefault();
  },
  toggleShowAddConversationButton: function toggleShowAddConversationButton(editorState) {
    (0, _conversationsHelpers.toggleBodyShowAddConversationButton)(Object.assign({}, this.props, {
      editorState: editorState
    }));
  },
  onChange: function onChange(changed) {
    this.userHasTyped = changed.getCurrentContent().hasText();
    var editorState = changed;

    if (['undo', 'insert-fragment'].includes(changed.getLastChangeType())) {
      // Force editor selection on an undo change
      editorState = _draftJs.EditorState.forceSelection(changed, changed.getSelection());
    }

    var currentBlockType = _draftJs.RichUtils.getCurrentBlockType(editorState);

    if (['header-two', 'header-three', 'blockquote'].includes(currentBlockType) && editorState.getLastChangeType() === 'split-block' && document.getSelection().anchorOffset !== 0) {
      // when the user hits enter after typing a header or quote, we want to toggle the header style for the user,
      // but only if the cursor isn't at the beginning of the line, otherwise we should just use default behavior.
      // Unfortunately, this leads to a small bug when the user tries to undo after splitting a block here, where
      // it will count the block type toggle as an undo state - easy to fix for them, but it may seem weird to users
      editorState = _draftJs.RichUtils.toggleBlockType(editorState, currentBlockType);
    }

    this.toggleShowAddConversationButton(editorState);
    this.props.updateContentToSave(editorState);
  },
  trackPasteEvent: function trackPasteEvent(subtype, length) {
    (0, _UsageTracking.trackEvent)({
      action: 'paste',
      name: _constants.AmplitudeEvents.COMPOSITION_INTERACTION.INTERACTION,
      what_event_subtype: subtype,
      what_value: length
    });
  },
  insertTextFromPaste: function insertTextFromPaste(html, clean, subtype, length) {
    var _this$props5 = this.props,
        composerSettings = _this$props5.composerSettings,
        saveState = _this$props5.saveState;
    var content = saveState.content;
    var pastedBlockMap = (0, _editorConfigs.convertFromHTML)(composerSettings, this.buildEditorOptions())(clean(html)).blockMap;

    var newState = _draftJs.Modifier.replaceWithFragment(content.getCurrentContent(), content.getSelection(), pastedBlockMap);

    this.props.updateContentToSave(_draftJs.EditorState.push(content, newState, 'insert-fragment'));
    this.trackPasteEvent(subtype, length);
    return HANDLED;
  },
  handlePastedText: function handlePastedText(text, html) {
    var textLength = text ? text.length : 'unknown';
    this.userHasPastedContent = true;

    if (html && html.match(DOCS_TEST)) {
      return this.insertTextFromPaste(html, _convertGoogleToHTML.convertGoogleToHTML, 'google-docs', textLength);
    }

    if (html && html.match(WORD_TEST)) {
      return this.insertTextFromPaste(html, _convertMSWordToHTML.default, 'ms-word', textLength);
    }

    if (html && html.match(EVERNOTE_TEST)) {
      return this.insertTextFromPaste(html, _convertEvernoteToHTML.default, 'evernote', textLength);
    }

    if (html) {
      return this.insertTextFromPaste(html, function (h) {
        return h;
      }, 'unknown-source', textLength);
    }

    this.trackPasteEvent('unknown-source', textLength);
    return NOT_HANDLED;
  },
  handleReturn: function handleReturn() {
    var editorState = this.props.saveState.content;
    var selection = editorState.getSelection();

    var currentBlockType = _draftJs.RichUtils.getCurrentBlockType(editorState);

    if (editorState.getLastChangeType() === 'split-block' && currentBlockType === 'unordered-list-item') {
      // handleReturn is called before `onChange` is triggered, so if the last change type is split-block
      // and we're inside of a list then we've hit the end of the list, go back to regular unstyled blocks
      editorState = _draftJs.RichUtils.toggleBlockType(editorState, currentBlockType);
      this.props.updateContentToSave(editorState);
      return HANDLED;
    } else if (currentBlockType === 'atomic' && editorState.getSelection().isCollapsed()) {
      var block = new _draftJs.ContentBlock({
        key: (0, _draftJs.genKey)()
      }); // Insert an unstyled block instead of another atomic block

      var contentState = (0, _contentStateModifier.insertBlockAfter)(editorState.getCurrentContent(), selection.getStartKey(), block);
      editorState = _draftJs.EditorState.push(editorState, contentState, 'split-block');
      editorState = _draftJs.EditorState.forceSelection(editorState, selection.merge({
        anchorKey: block.getKey(),
        anchorOffset: 0,
        focusKey: block.getKey(),
        focusOffset: 0
      }));
      this.props.updateContentToSave(editorState);
      return HANDLED;
    }

    return NOT_HANDLED;
  },
  onTab: function onTab(e) {
    // by default draft-js only allows a list depth of 1, this bumps it to 3
    this.props.updateContentToSave(_draftJs.RichUtils.onTab(e, this.props.saveState.content, 2
    /* zero-indexed */
    ));
    return HANDLED;
  },
  onFocus: function onFocus() {
    this.props.setBodyEditorActive(true);
  },
  keyBindingFn: function keyBindingFn(e) {
    var content = this.props.saveState.content;

    if (this.getCommentsOnly()) {
      return HANDLED;
    }

    var selection = content.getSelection();

    if (e.keyCode === _KeyCodes.BACKSPACE && !selection.getAnchorOffset() && !selection.getFocusOffset()
    /* cursor is at beginning of block */
    ) {
        var currentKey = selection.getAnchorKey();
        var prevBlock = content.getCurrentContent().getBlockBefore(currentKey); // no prevBlock if it's the first block on the page

        if (prevBlock && prevBlock.type === 'atomic') {
          return _constants.KeyCommands.DELETE_IMAGE;
        }
      }

    return (0, _draftJs.getDefaultKeyBinding)(e);
  },
  focus: function focus() {
    if (this._editor) {
      this._editor.focus();

      this.onFocus();
    }
  },
  blur: function blur() {
    if (this._editor) {
      this._editor.blur();
    }
  },
  handleImportGoogleDocClick: function handleImportGoogleDocClick() {
    var _this$props$googleDoc = this.props.googleDocs,
        token = _this$props$googleDoc.token,
        tokenRequestStatus = _this$props$googleDoc.tokenRequestStatus;
    (0, _UsageTracking.trackEvent)({
      action: 'google-docs-import',
      name: _constants.AmplitudeEvents.COMPOSITION_INTERACTION.INTERACTION
    });

    if ([_constants.RequestStatus.FAILED, _constants.RequestStatus.SUCCEEDED].includes(tokenRequestStatus) && !token) {
      this.props.showGoogleAuthModal();
    } else {
      this.props.showGoogleDocsPicker();
    }
  },
  getPlaceholder: function getPlaceholder(type, typeString) {
    if (this.getReadOnly() && type !== _constants.CompositionTypes.KNOWLEDGE_ARTICLE) {
      return null;
    }

    return this.context.gates.has(_constants.GOOGLE_DRIVE_GATE) ? _I18n.default.text("composer-lib.composer.bodyPlaceholderNew." + typeString) : _I18n.default.text("composer-lib.composer.bodyPlaceholder." + typeString);
  },
  renderGoogleDocInsertArea: function renderGoogleDocInsertArea() {
    var _this$props6 = this.props,
        composerSettings = _this$props6.composerSettings,
        googleDocs = _this$props6.googleDocs,
        saveState = _this$props6.saveState;
    var gates = this.context.gates;
    var bodyEditorState = saveState.content;
    var bodyContentState = bodyEditorState.getCurrentContent();
    var bodyIsEmpty = !bodyContentState.hasText();
    var loadingAccessToken = googleDocs.tokenRequestStatus === _constants.RequestStatus.PENDING;

    if (!composerSettings.get('features')[_constants.ComposerFeatures.GOOGLE_DOCS] || !window.google || loadingAccessToken || !bodyIsEmpty || !gates.has(_constants.GOOGLE_DRIVE_GATE) || this.getCommentsOnly() || this.getReadOnly()) {
      return null;
    }

    return _react.default.createElement("div", {
      className: "google-doc-import-area text-center p-y-5"
    }, _react.default.createElement(_UIBadge.default, {
      className: "google-doc-beta-badge",
      use: "beta"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "composer-lib.global.beta"
    })), _react.default.createElement("div", {
      className: "m-bottom-3 text-center"
    }, _react.default.createElement(_UIIllustration.default, {
      name: "text-snippet",
      width: "10%"
    })), _react.default.createElement(_UIButton.default, {
      onClick: this.handleImportGoogleDocClick,
      use: "link"
    }, renderMessage('googleDocButtonText')), _react.default.createElement("span", {
      className: "m-left-1"
    }, renderMessage('googleDocEndText')));
  },
  renderLabel: function renderLabel(required, showLabel, typeString, editorState) {
    if (!showLabel) {
      return null;
    }

    return _react.default.createElement(_UIFormLabel.default, {
      className: (0, _classnames.default)({
        'visibility-hidden': this.userHasTyped || editorState.getCurrentContent().hasText()
      }),
      required: required
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "composer-lib.composer.bodyLabel." + typeString
    }));
  },
  render: function render() {
    var _this = this;

    var _this$props7 = this.props,
        addKeyCommandListener = _this$props7.addKeyCommandListener,
        composerSettings = _this$props7.composerSettings,
        _this$props7$composit = _this$props7.composition,
        type = _this$props7$composit.type,
        typeString = _this$props7$composit.typeString,
        containerClassNames = _this$props7.containerClassNames,
        editorClassNames = _this$props7.editorClassNames,
        handleKeyCommand = _this$props7.handleKeyCommand,
        removeKeyCommandListener = _this$props7.removeKeyCommandListener,
        required = _this$props7.required,
        saveState = _this$props7.saveState,
        showLabel = _this$props7.showLabel,
        tabIndex = _this$props7.tabIndex;

    if (!saveState.content) {
      return null;
    }

    var hidePlaceholder = (0, _utils.shouldHidePlaceholder)(saveState.content);
    var containerClasses = (0, _classnames.default)(_constants.BODY_EDITOR_CLASSNAME, containerClassNames);
    var editorClasses = (0, _classnames.default)('composition-body', editorClassNames, {
      'composer-width m-x-auto': composerSettings.get('fullScreen'),
      'hide-placeholder': hidePlaceholder
    });
    return _react.default.createElement("div", {
      className: containerClasses
    }, _react.default.createElement("div", {
      className: editorClasses,
      onClick: this.focus
    }, this.renderLabel(required, showLabel, typeString, saveState.content), _react.default.createElement(this.EditorWithPlugins, {
      addKeyCommandListener: addKeyCommandListener,
      editorState: saveState.content,
      ref: function ref(c) {
        return _this._editor = c;
      },
      handleKeyCommand: handleKeyCommand,
      handlePastedText: this.handlePastedText,
      handleReturn: this.handleReturn,
      keyBindingFn: this.keyBindingFn,
      onChange: this.onChange,
      onFocus: this.onFocus,
      onTab: this.onTab,
      placeholder: this.getPlaceholder(type, typeString),
      readOnly: this.getReadOnly() || saveState.insertableLoading,
      removeKeyCommandListener: removeKeyCommandListener,
      showButtons: false,
      spellCheck: true,
      tabIndex: tabIndex
    }), this.renderGoogleDocInsertArea()));
  }
});

var _default = (0, _reactKeybindings.KeyboundComponent)(BodyEditor);

exports.default = _default;
module.exports = exports.default;